<template>
  <select v-model="selected">
    <option disabled :value="null">Please select one</option>
    <option
      v-for="booth of booths"
      :key="booth.id"
      :value="booth"
    >
      {{ booth.building }} - {{ booth.room }} - {{ booth.number }}
    </option>
  </select>
</template>

<script lang="ts">
import _ from 'lodash'
import { Booth, BoothConditions } from '@/store/booths/types';
import { Campus, University } from '@/store/master/types';
import { RootState } from '@/store/types';
import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator'

@Component
export default class SelectBoothInput extends Vue {
  @Prop() value?: Booth

  @Prop({ required: true }) university!: University

  @Prop() campus?: Campus

  private get selected(): Booth|null {
    return this.value || null
  }

  private set selected(booth: Booth|null) {
    this.$emit('input', booth)
  }

  private get booths(): Booth[] {
    const { booths } = (this.$store.state as RootState).booths
    if (!this.campus) {
      return booths
    }

    return _.filter(booths, (booth: Booth) => booth.campus.code === this.campus?.code)
  }

  private created() {
    const conditions: BoothConditions = {
      university: this.university,
      campuses: this.campus ? [this.campus] : [],
      removedPagingLimit: true,
    }

    this.$store.dispatch('fetchBooths', { conditions })
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
